import AuthService from "../../service";
const menu = {
  getMenu(page,search,sort_branch,sort_date) {
    return AuthService.get(`menu/menus?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&sort_branch=${sort_branch}` +
      `&search=${search}`
    );
  },
  showMenu(id) {
    return AuthService.get("/menu/menus/" + id);
  },
  createMenu(data) {
    return AuthService.post("/menu/menus", data);
  },
  updateMenu(id, data) {
    return AuthService.put("/menu/menus/" + id, data);
  },
  deleteMenu(id) {
    return AuthService.delete("/menu/menus/" + id);
  },
  getAllMenu() {
    return AuthService.get("/menu/get_menu_all");
  }
};
export default menu;
